/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1679961600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Tue Mar 28 2023 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "bingads",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Bing Ads",
          "depth": 0,
          "id": "connect-to-bing-ads"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing events",
          "depth": 1,
          "id": "syncing-events"
        }, {
          "value": "Syncing audiences",
          "depth": 1,
          "id": "syncing-audiences"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Matched users count",
          "depth": 1,
          "id": "matched-users-count"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      p: "p",
      h3: "h3",
      h4: "h4",
      code: "code",
      ul: "ul",
      li: "li"
    }, _provideComponents(), props.components), {EventSyncWarning, MatchBoosterDestination, MatchRatesExplanation, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!MatchBoosterDestination) _missingMdxReference("MatchBoosterDestination", true);
    if (!MatchRatesExplanation) _missingMdxReference("MatchRatesExplanation", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Events"
              })
            }), _jsx(_components.td, {
              children: "Sync offline conversion events with data from any source"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://learn.microsoft.com/en-us/advertising/bulk-service/offline-conversion",
                children: "Offline conversion reference"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Audiences"
              })
            }), _jsx(_components.td, {
              children: "Create new or use an existing audience to sync users"
            }), _jsx(_components.td, {
              children: "Add, Remove"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://learn.microsoft.com/en-us/advertising/bulk-service/customer-list-item",
                children: "Customer list item reference"
              })
            })]
          })]
        })]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-bing-ads",
        children: "Connect to Bing Ads"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Bing Ads"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to Bing Ads using OAuth."]
      }), "\n", _jsxs(_components.p, {
        children: ["Click ", _jsx(_components.strong, {
          children: "Log in to Microsoft Bing Ads"
        }), " , log in with your Microsoft Ads account, and click ", _jsx(_components.strong, {
          children: "Allow"
        }), ".\nHightouch requires access to manage your ads account and see your email address.\nOnce successful, you will be redirected back to Hightouch to enter a descriptive name for your destination and complete setup."]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Bing Ads destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Bing Ads destination you want to sync to."]
      }), "\n", _jsx(_components.p, {
        children: "Whether you're syncing events or audiences, begin your configuration by selecting the Microsoft Ads account you want to sync data to."
      }), "\n", _jsx(_components.h3, {
        id: "syncing-events",
        children: "Syncing events"
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing offline conversion events, Hightouch treats any records added to ", _jsx(_components.a, {
          href: "/getting-started/concepts",
          children: "your source"
        }), " as new events and sends them to Bing Ads when your sync runs."]
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h4, {
        id: "conversion-goal-name",
        children: "Conversion goal name"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.a, {
          href: "https://help.ads.microsoft.com/#apex/ads/en/56689/2",
          children: "conversion goal name"
        }), " to associate with the offline conversions.\nYour options populate depending on the Microsoft Ads account you selected at the beginning of the sync configuration."]
      }), "\n", _jsx(_components.h4, {
        id: "event-timestamp",
        children: "Event timestamp"
      }), "\n", _jsxs(_components.p, {
        children: ["You can optionally select a column that contains timestamps of when events occurred. If this field is empty, Hightouch uses the time the event arrives at the server. Hightouch syncs the timestamp as the ", _jsx(_components.code, {
          children: "ConversionTime"
        }), " parameter the Microsoft Advertising API requires."]
      }), "\n", _jsx(_components.p, {
        children: "The timestamp field must also:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "be in Coordinated Universal Time (UTC)"
        }), "\n", _jsxs(_components.li, {
          children: ["be later than the recorded ", _jsx(_components.strong, {
            children: "Microsoft Click ID"
          })]
        }), "\n", _jsx(_components.li, {
          children: "be within the conversion goal window"
        }), "\n", _jsx(_components.li, {
          children: "be within the last 90 days"
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information, see ", _jsx(_components.a, {
          href: "https://learn.microsoft.com/en-us/advertising/bulk-service/offline-conversion",
          children: "Microsoft Bing Ads' official documentation"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you sync event fields via field mapping.\nYou can map data from any of your model columns to ", _jsx(_components.a, {
          href: "https://learn.microsoft.com/en-us/advertising/bulk-service/offline-conversion?view=bingads-13",
          children: "supported event fields"
        }), ".\nThe Microsoft Ads API requires the ", _jsx(_components.strong, {
          children: "Microsoft Click ID"
        }), " field, so you must map it to complete your configuration.\nEnsure your model columns data types match the data types of the fields you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-audiences",
        children: "Syncing audiences"
      }), "\n", _jsx(_components.p, {
        children: "You can use Hightouch to insert and update audience members in a the Bing Ads customer match list audience.\nUsers removed from the model get removed from the audience."
      }), "\n", _jsx(Warning, {
        children: _jsx(_components.p, {
          children: "To sync to a customer match list audience, you need to first create a customer\nlist and accept terms and conditions in the Microsoft Advertising UI."
        })
      }), "\n", _jsx(_components.h4, {
        id: "select-an-existing-audience-or-create-a-new-one",
        children: "Select an existing audience or create a new one"
      }), "\n", _jsx(_components.p, {
        children: "You can create a new audience or use an existing one. When creating a new audience, you can optionally enter a name; otherwise, Hightouch defaults to the name of the associated model. To use an existing audience, select the desired audience from the dropdown."
      }), "\n", _jsx(_components.h4, {
        id: "user-identifiers",
        children: "User identifiers"
      }), "\n", _jsxs(_components.p, {
        children: ["Bing Ads requires you to identify which users to add or update in an audience on a valid ", _jsx(_components.strong, {
          children: "Email"
        }), ".\nSelect the model column that contains user emails."]
      }), "\n", _jsxs(_components.p, {
        children: ["Bing Ads doesn't support mapping any other fields.\nFor more information, see ", _jsx(_components.a, {
          href: "https://learn.microsoft.com/en-us/advertising/bulk-service/customer-list-item?view=bingads-13#subtype",
          children: "Microsoft Bing Ads' official documentation"
        }), "."]
      }), "\n", _jsx(MatchBoosterDestination, {
        destinationName: "Bing Ads audiences"
      }), "\n", _jsx(_components.h4, {
        id: "handling-pii",
        children: "Handling PII"
      }), "\n", _jsxs(_components.p, {
        children: ["By default, Hightouch automatically detects if your ", _jsx(_components.strong, {
          children: "Email"
        }), " field requires hashing and hashes the value before sending requests to Bing Ads if needed."]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "matched-users-count",
        children: "Matched users count"
      }), "\n", _jsx(_components.p, {
        children: "Below only applies to the audiences sync type."
      }), "\n", _jsx(MatchRatesExplanation, {
        destination: "Bing Ads"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", "\n", _jsx(_components.h4, {
        id: "8003-customerlisttermsandconditionsnotaccepted",
        children: "8003: CustomerListTermsAndConditionsNotAccepted"
      }), "\n", _jsx(_components.p, {
        children: "To sync to a customer match list audience, you need to first create a customer list and accept terms and conditions in the Microsoft Advertising UI."
      }), "\n", _jsxs(_components.p, {
        children: ["For more information, read the ", _jsx(_components.a, {
          href: "https://learn.microsoft.com/en-us/advertising/bulk-service/customer-list-item?view=bingads-13",
          children: "Bing Ads documentation"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "error-uploading-audience-xxx-bulk-operation-failed---4835---invalidaudienceid-in-path",
        children: "Error uploading audience XXX, bulk operation failed: - (4835) - InvalidAudienceId in path"
      }), "\n", _jsx(_components.p, {
        children: "Check the Bing Ads UI to make sure the audience from your sync configuration exists. If the audience no longer exists, you need to create a new sync."
      }), "\n", _jsxs(_components.p, {
        children: ["For additional errors, read the Bing Ads ", _jsx(_components.a, {
          href: "https://learn.microsoft.com/en-us/advertising/guides/operation-error-codes?view=bingads-13",
          children: "error codes documentation"
        }), "."]
      }), "\n", "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
